import { createBrowserClient } from "@supabase/ssr";
import { ROOT_DOMAIN } from "../utils/navigation-utils";
import { isVercelPreviewDeploy } from "../utils/orgHostRouting";
import { Database } from "../types/database.types";
import { TypedSupabaseClient } from "../types/supabase.types";
export function createClient() {
  // Create a supabase client on the browser with project's credentials
  const isPreview = isVercelPreviewDeploy();
  return createBrowserClient<Database>(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
    {
      cookieOptions:
        process.env.NODE_ENV === "production"
          ? {
              ...(!isPreview ? { domain: ROOT_DOMAIN } : {}),
              path: "/",
              maxAge: 60 * 60 * 24,
              sameSite: "lax" as const,
              secure: true,
            }
          : {},
    }
  ) as TypedSupabaseClient;
}
